module.exports = __webpack_public_path__ + "static/media/usage.0f43b5fc.svg";